import React from "react";
const SetInnerHtml = (props) => {
  const { data, className, id } = props;

  return (
    <>
      <div
        id={id ? id : ""}
        className={className ? className : ""}
        dangerouslySetInnerHTML={{ __html: data ? data : "" }}
      />
    </>
  );
};

export default SetInnerHtml;
